"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _uxcore = require("@ux/uxcore2");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _storeProvider = require("../util/storeProvider");
var _JsonComponent = require("./JsonComponent");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class EnvironmentDataComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: 0,
      left: '99%',
      open: false
    };
    this.handleScrollOrSize = this.handleScrollOrSize.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  toggle() {
    let {
      open
    } = this.state;
    open = !open;
    this.setState({
      open
    }, () => {
      this.handleScrollOrSize();
    });
  }
  handleScrollOrSize() {
    if (this.state.open) {
      this.setState({
        top: `${window.pageYOffset}px`,
        right: 0,
        left: 'unset'
      });
    } else {
      this.setState({
        top: `${window.pageYOffset}px`,
        left: '100%',
        right: '10px'
      });
    }
  }
  render() {
    const data = this.context.store.getState();
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: !this.state.open ? {
        marginTop: '40px'
      } : {
        textAlign: 'left',
        position: 'fixed',
        top: 0,
        left: `${this.state.left}`,
        right: `${this.state.right}`,
        bottom: 0,
        width: '400px',
        padding: '10px',
        overflow: 'auto',
        backgroundColor: '#ddd',
        zIndex: 10000
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: this.state.open ? '' : 'card ux-card'
    }, /*#__PURE__*/React.createElement("div", {
      className: this.state.open ? '' : 'card-block'
    }, /*#__PURE__*/React.createElement(_uxcore.Button, {
      onClick: this.toggle,
      design: "inline",
      text: "Internal Only"
    }), /*#__PURE__*/React.createElement(_JsonComponent.JsonComponent, {
      open: ['data', 'data.layout', 'data.layout.pages', 'data.instance', 'data.environment', 'data.environment.experiments', 'orderSummary', 'orderSummary.selections', 'constants'],
      name: "state",
      data: data
    })))));
  }
}
EnvironmentDataComponent.propTypes = {
  containerDiv: _propTypes.default.object
};
var _default = exports.default = (0, _storeProvider.provideContext)(EnvironmentDataComponent);